export default "__VITE_ASSET__BKnLZt1H__"